export default "__VITE_ASSET__3b720e47__"